__turbopack_context__.v({
  "arrow": "VerticalRow-module__UcAQxa__arrow",
  "left": "VerticalRow-module__UcAQxa__left",
  "leftGradient": "VerticalRow-module__UcAQxa__leftGradient",
  "right": "VerticalRow-module__UcAQxa__right",
  "rightGradient": "VerticalRow-module__UcAQxa__rightGradient",
  "slider": "VerticalRow-module__UcAQxa__slider",
  "sliderWrapper": "VerticalRow-module__UcAQxa__sliderWrapper",
  "title": "VerticalRow-module__UcAQxa__title",
});
